export default {
    create_company_modal: {
        title: 'Kreiranje kompanije',
    },
    change_password: {
        title: 'Promena loznike',
    },
    change_email: {
        title: 'Promena email-a',
    },
    change_phone: {
        title: 'Promena broja telefona',
    },
    verify_phone: {
        title: 'Verifikacija broja telefona',
    },
    add_credentials: {
        title: 'Dodavanje kredencijala',
    },
    add_password: {
        title: 'Dodavanje lozinke',
    },
    invite_company_user: {
        title: 'Pozivanje korisnika u kompaniju',
    },
    change_role_company_user: {
        title: 'Promena uloge korisniku u kompaniji',
    },
    delete_offer: {
        title: 'Da li ste sigurni da želite da obrišete uslugu?',
    },
    delete_discount: {
        title: 'Da li ste sigurni da želite da obrišete popust?',
    },
    extend_offer: {
        title: 'Da li ste sigurni da želite da produžite uslugu?',
    },
    delete_company_user: {
        title: 'Da li ste sigurni da želite da obrišete korisnika iz kompanije??',
    },
    confirm_reservation_modal: {
        add_note: 'Unesite napomenu..',
        reservation_succeeded:
            'Čestitamo! Uspešno ste napravili rezervaciju. Bićete obavešteni kada vaša rezervacija bude prihvaćena.',
        reschedule_succeeded: 'Čestitamo! Uspešno ste odgodili rezervaciju.',
        blocked_reservation: 'Rezervacije ove usluge su moguće samo putem telefona!',
        slot_taken: 'Ovo vreme je vec rezervisano! Molimo vas odaberite drugo.',
        user_blocked: 'Kompanija je blokirala nalog!',
        two_hours_ahead: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum dva sata unapred.',
        location: 'Lokacija',
        date_and_time: 'Datum i vreme',
        price: 'Cena',
        confirm_reservation: 'Molimo potvrdite Vašu rezervaciju',
        reservation_confirmed_info: 'Hvala Vam. Rezervacija je poslata',
        reservation_confirmed_heading: 'Termin je uspešno rezervisan!',
        reservation_confirmed_subtitle:
            'Status Vaše rezervacije možete da pogledate u Moje rezervacije - Kreirane. Nakon potvrde ili promene statusa rezervacije bićete obavešteni e-mailom.',
        owner_reservation_confirmed_subtitle:
            ' Vaša rezervacija je uspešno kreirana. Hvala što koristite bookeraj! Uživajte u svom poslu.',
        reschedule_confirmed_reservation: 'Rezervacija je već prihvaćena i termin ne može biti promenjen.',
        mins_ahead_7200: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum pet dana unapred.',
        mins_ahead_5760: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum četiri dana unapred.',
        mins_ahead_4320: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum tri dana unapred.',
        mins_ahead_2880: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum dva dana unapred.',
        mins_ahead_1440: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum jedan dan unapred.',
        mins_ahead_240: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum ćetiri sata unapred.',
        mins_ahead_180: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum tri sata unapred.',
        mins_ahead_120: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum dva sata unapred.',
        mins_ahead_90: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum sat i po unapred.',
        mins_ahead_60: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum jedan sat unapred.',
        mins_ahead_45: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum 45 minuta unapred.',
        mins_ahead_30: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum 30 minuta unapred.',
        mins_ahead_20: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum 20 minuta unapred.',
        mins_ahead_15: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum 15 minuta unapred.',
        mins_ahead_10: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum 10 minuta unapred.',
        mins_ahead_5: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum 5 minuta unapred.',
        mins_ahead_1: 'Ovaj vreme nije moguće rezervisati. Molimo izaberite vreme koje je minimum 1 minut unapred.',
    },
    custom_reservation_modal: {
        info: 'Slobodna rezervacija omogućava rezervaciju usluge čak i izvan radnog vremena pružajući vam maksimalnu fleksibilnost, preklapanje i slobodan izbor pocetka termina.',
    },
    out_of_availability_modal: {
        warning: 'Neke od vaših rezervacija će biti odložene nakon dodavanja neaktivnosti',
        falling_out: `Jeste sigurni da želite da dodate neaktivnost?`,
        offer_name: 'Usluga: {name}',
        number_rescheduled_reservations: 'Broj rezervacija koji će biti odložen: {n}',
    },
    add_inactivity_modal: {
        multi_select_input: {
            label_input: 'Raspored',
            placeholder_input: `Izaberite rasporede`,
        },
        checkbox_label: 'Da li želite da dodate neaktivnost za sve usluge kojima je dodijeljen ovaj raspored?',
    },
    complete_profile_modal: {
        create_company_service: 'Da biste koristili ovu opciju morate popuniti svoj profil.',
        complete_first_and_last_name: 'Da biste koristili ovu opciju morate popuniti ime i prezime.',
        complete_mobile_phone: 'Da biste koristili ovu opciju morate popuniti broj telefona.',
    },
    add_inactivity: {
        title: 'Dodaj neaktivnost',
    },
    remove_inactivity: {
        title: 'Da li sigurno da želite ukloniti neaktivnost?',
    },
    location_used_modal: {
        title: 'Nije moguće obrisati ovu lokaciju!',
        warning: 'Morate ukloniti ovu lokaciju sa sledećih usluga:',
    },
    delete_location: {
        title: 'Da li ste sigurni da želite da izbrišete lokaciju?',
    },
    add_availability: {
        heading: 'Unesite detalje rasporeda',
    },
    complete_profile: {
        heading: 'Molimo vas dovršite Vaš profil',
        description: 'Ovi podaci su neophodni kako biste mogli rezervisati usluge!',
        steps: {
            step_1: 'Ime i prezime',
            step_2: 'Broj telefona',
        },
    },

    cookies: {
        message:
            'Naš pravni tim nas je savetovao da vas obavestimo da koristimo kolačiće u cilju unapređenja korisničkog iskustva.',
        button: 'Prihvatam kolačiće',
    },
}
